
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientCustom } from './http-client';
import { SERVICE_URL } from '../constants/global';
import { ReturnStatusHtml } from '../models/returnStatus';
import { Budget } from '../models/budget'; // ALTERAR
import { MasterService } from './master.service';
import { Observable } from 'rxjs';

import { DatatableParameters } from '../models/datatable-parameters';
import { AuthenticationService } from './authentication.service';
import { CostCenterDistribution } from '../models/cost-center-distribution';

@Injectable()
export class BudgetService {

  private _controller: string = 'Budget';

  datatableParameters: DatatableParameters = new DatatableParameters([null, null, null, null, null], 10, [[0, 'asc']], 0);

  constructor(private http: HttpClientCustom, private _masterService: MasterService, private authenticationService: AuthenticationService) { }

  /**
   * Eliminar budget
   * @param  {number} id
   * @returns Observable
   */
  delete(id: number): Observable<ReturnStatusHtml> {
    return this.http.delete(SERVICE_URL + this._controller + '/Delete?id=' + id).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  // editar budget
  /**
   * @param  {Budget} budget
   * @returns Observable
   */
  update(budget: Budget): Observable<ReturnStatusHtml> {
    return this.http.post(SERVICE_URL + this._controller + '/Update', budget).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  // adicionar budget
  /**
   * @param  {Budget} budget
   * @returns Observable
   */
  add(budget: Budget): Observable<ReturnStatusHtml> {
    return this.http.put(SERVICE_URL + this._controller + '/Add', budget).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  /**
   * Obter budget por id
   * @param  {number} id
   * @returns Observable
   */
  get(id: number): Observable<ReturnStatusHtml> {
    return this.http.get(SERVICE_URL + this._controller + '/Get?id=' + id).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));

  }

  getMovements(id: number): Observable<ReturnStatusHtml> {
    return this.http.get(SERVICE_URL + this._controller + '/GetMovements?id=' + id).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));

  }

  /**
   * Obter valor acumulado
   * @param  {number} id
   * @returns Observable
   */
  getBudgetOrderSum(id: number): Observable<ReturnStatusHtml> {
    return this.http.get(SERVICE_URL + this._controller + '/GetBudgetOrderSum?id=' + id).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));

  }

  /**
   * Obter budgets
   * @param  {number} userID
   * @param  {number} locationID
   * @param  {number} costCenterID
   * @returns Observable
   */
  /*
  GetBudgetsByAssociations(userID: number, locationID: number, costCenterID: number): Observable<ReturnStatusHtml> {
    return this.http.get(SERVICE_URL + this._controller + '/GetBudgetsByAssociations?userID=' + userID + '&locationID=' + locationID + '&costCenterID=' + costCenterID).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }*/
  GetBudgetsByAssociations(date: Date, userID: number, locationID: number, costCentersID: Array<number>, genericFields:{[key: string]: string[]}, isRequest: boolean, ccd: CostCenterDistribution[]): Observable<ReturnStatusHtml> {
    return this.http.post(SERVICE_URL + this._controller + '/GetBudgetsByAssociations', { date, userID, locationID, costCentersID, genericFields, isRequest, costCenterDistribution: ccd}).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  private availableDropDownList: any[]
  get_DropDownListAssociation(defaultValue: any[]): any[] {
    if (typeof this.availableDropDownList === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('Budgets', 'AvailableDropDownList');
      if (settingValue != null) {
        this.availableDropDownList = settingValue;
      } else {
        this.availableDropDownList = defaultValue;
      }
    }
    return this.availableDropDownList;
  }

  private showEndDate: boolean
  get_ShowEndDate(defaultValue: boolean): boolean {
    if (typeof this.showEndDate === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('Budgets', 'ShowEndDate');
      if (settingValue != null) {
        this.showEndDate = settingValue;
      } else {
        this.showEndDate = defaultValue;
      }
    }
    return this.showEndDate;
  }

  private showHistory: boolean
  get_ShowHistory(defaultValue: boolean): boolean {
    if (typeof this.showHistory === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('Budgets', 'ShwoHistory');
      if (settingValue != null) {
        this.showHistory = settingValue;
      } else {
        this.showHistory = defaultValue;
      }
    }
    return this.showHistory;
  }

  private otherColumns: any[]
  get_OtherColumns(defaultValue: any[]): any[] {
    if (typeof this.otherColumns === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('Budgets', 'OtherColumns');
      if (settingValue != null) {
        this.otherColumns = settingValue;
      } else {
        this.otherColumns = defaultValue;
      }
    }
    return this.otherColumns;
  }

  private showIsWorkflowBudgetFromOrders: boolean
  get_showIsWorkflowBudgetFromOrders(defaultValue: boolean): boolean {
    if (typeof this.showIsWorkflowBudgetFromOrders === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('Budgets', 'ShowIsWorkflowBudgetFromOrders');
      if (settingValue != null) {
        this.showIsWorkflowBudgetFromOrders = settingValue;
      } else {
        this.showIsWorkflowBudgetFromOrders = defaultValue;
      }
    }
    return this.showIsWorkflowBudgetFromOrders;
  }
}
